import script from "./PlatformSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformSettings.vue?vue&type=script&setup=true&lang=js"

import "./PlatformSettings.vue?vue&type=style&index=0&id=dbcf246a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbcf246a"]])

export default __exports__